interface MessageTahitiProps {
  /** The `error_message` of Tahiti, already found readable by the client (`messageLisible`). */
  message: string;
}

/**
 * The error message of Tahiti, shown as it is (#13): Rosetta does not rewrite it, it says whose
 * words they are and quotes them. The screens call Tahiti "le service" (as in "Le service est
 * indisponible."): the name of the platform means nothing to a client. On a failed, partial or
 * blocked translation.
 */
export function MessageTahiti({ message }: MessageTahitiProps) {
  return (
    <p className="break-words text-gray-700 text-small leading-[1.5]">
      Message du service de traduction : « <span className="text-black">{message}</span> »
    </p>
  );
}
